<template>
  <a
    class="conversation flex flex-shrink-0 flex-grow-0 w-auto max-w-full cursor-pointer relative py-0 px-4 border-transparent border-l-2 border-t-0 border-b-0 border-r-0 border-solid items-start hover:bg-slate-25 dark:hover:bg-slate-800 group"
    :class="{
      'active bg-slate-25 dark:bg-slate-800 active-class':
        isActiveChat && !isDetachedHighlight,
      'active detached-highlight': isDetachedHighlight,
      'unread-chat': hasUnread,
      'has-inbox-name': showInboxName,
      'conversation-selected': selected,
    }"
    @mouseenter="onCardHover"
    @mouseleave="onCardLeave"
    @click="onCardClick"
    @contextmenu="openContextMenu($event)"
  >
  <!-- @click="onCardClick"      :href="contactchatLink"  target="_blank" -->
    <label
      v-if="hovered || selected"
      class="checkbox-wrapper thumbnail-columns"
      @click.stop
    >
      <input
        :value="selected"
        :checked="selected"
        class="checkbox"
        type="checkbox"
        @change="onSelectConversation($event.target.checked)"
      />
    </label>
    <thumbnail
      v-if="bulkActionCheck"
      :src="showAssigneeName && assignee.thumbnail ? assignee.thumbnail : currentContact.thumbnail"
      :badge="inboxBadge"
      class="columns thumbnail-columns"
      :username="displayName"
      :status="showAssigneeName && assignee.availability_status ? assignee.availability_status : currentContact.availability_status"
      size="50px"
    />
    <div
      class="py-3 px-0 border-b group-last:border-transparent group-hover:border-transparent border-slate-50 dark:border-slate-800/75 columns"
    >
      <div class="flex justify-between">
        <!-- <inbox-name v-if="showInboxName" :inbox="inbox" /> -->
        <div class="flex gap-2 ml-2 rtl:mr-2 rtl:ml-0">
          <span
            v-if="showAssignee && assignee.name"
            class="text-slate-500 dark:text-slate-400 text-xs font-medium leading-3 py-0.5 px-0 inline-flex text-ellipsis overflow-hidden whitespace-nowrap"
            :class="{
                'dark:text-slate-800': isActiveChat,
            }"
          >
            <fluent-icon
              icon="person"
              size="12"
              class="text-slate-500 dark:text-slate-400"
            />
            {{ assignee.name }}
          </span>
          <priority-mark :priority="chat.priority" />
        </div>
      </div>
      <div
        class="conversation--user-row flex items-center min-w-0 mx-2 pt-0.5 pr-16 md:pr-20"
      >
        <div
          class="inline-flex items-center gap-1 min-w-0 max-w-full flex-1 overflow-hidden"
        >
          <h3
            class="text-color text-weight conversation--user text-sm my-0 capitalize text-ellipsis overflow-hidden whitespace-nowrap text-slate-900 dark:text-slate-100 min-w-0"
            :class="{
              'dark:text-slate-800': isActiveChat,
            }"
          >
            <span class="truncate min-w-0">{{ displayName }}</span>
            <lead-quality-crown
              v-if="!showAssigneeName && accountId"
              :account-id="accountId"
              :metadata="senderLeadQualityMetadata"
            />
            <lead-response-watch
              class="flex-shrink-0 self-center"
              :waiting-since-unix="displayWatchData.unix"
              :force-red="displayWatchData.forceRed"
            />
          </h3>
        </div>
      </div>
      <span v-if="typing" class="pl-2 custom-font-family">{{ $t('CHAT_LIST.TYPING') }}</span>
      <p
        v-if="lastMessageInChat && !typing"
        class="text-color-up conversation--message text-slate-700 dark:text-slate-200 text-sm my-0 mx-2 leading-6 h-6 max-w-[96%] w-[16.875rem] overflow-hidden text-ellipsis whitespace-nowrap"
      >
        <fluent-icon
          v-if="isMessagePrivate"
          size="16"
          class="-mt-0.5 align-middle text-slate-600 dark:text-slate-300 inline-block"
            :class="{
                'dark:text-slate-800': isActiveChat,
            }"
          icon="lock-closed"
        />
        <fluent-icon
          v-else-if="messageByAgent"
          size="16"
          class="-mt-0.5 align-middle text-slate-600 dark:text-slate-300 inline-block"
            :class="{
                'dark:text-slate-800': isActiveChat,
            }"
          icon="arrow-reply"
        />
        <fluent-icon
          v-else-if="isMessageAnActivity"
          size="16"
          class="-mt-0.5 align-middle text-slate-600 dark:text-slate-300 inline-block"
            :class="{
                'dark:text-slate-800': isActiveChat,
            }"
          icon="info"
        />
        <span v-if="lastMessageInChat.content" 
          :class="{
                'dark:text-slate-800': isActiveChat,
            }"
        >
          {{ parsedLastMessage }}
        </span>
        <span v-else-if="lastMessageInChat.attachments">
          <fluent-icon
            v-if="attachmentIcon"
            size="16"
            class="-mt-0.5 align-middle inline-block text-slate-600 dark:text-slate-300"
              :class="{
                'dark:text-slate-800': isActiveChat,
            }"
            :icon="attachmentIcon"
          />
          {{ this.$t(`${attachmentMessageContent}`) }}
        </span>
        <span v-else>
          {{ $t('CHAT_LIST.NO_CONTENT') }}
        </span>
      </p>
      <p
        v-else-if="!typing"
        class="text-color conversation--message text-slate-700 dark:text-slate-200 text-sm my-0 mx-2 leading-6 h-6 max-w-[96%] w-[16.875rem] overflow-hidden text-ellipsis whitespace-nowrap"
      >
        <fluent-icon
          size="16"
          class="-mt-0.5 align-middle inline-block text-slate-600 dark:text-slate-300"
            :class="{
                'dark:text-slate-800': isActiveChat,
            }"
          icon="info"
        />
        <span>
          {{ this.$t(`CHAT_LIST.NO_MESSAGES`) }}
        </span>
      </p>
      <div class="conversation--meta flex flex-col absolute right-4 top-4">
        <span class="text-black-600 text-xxs font-normal leading-4 ml-auto"
          :class="{
                'dark:text-slate-800': isActiveChat,
            }">
          <time-ago
            :last-activity-timestamp="chat.timestamp"
            :created-at-timestamp="chat.created_at"
          />
        </span>
        <span
          class="unread shadow-lg rounded-full hidden text-xxs font-semibold h-4 leading-4 ml-auto mt-1 min-w-[1rem] px-1 py-0 text-center text-white bg-custom-color"
            :class="{
                'dark:text-slate-800': isActiveChat,
            }"
        >
          {{ unreadCount > 9 ? '9+' : unreadCount }}
        </span>
      </div>
      <card-labels :conversation-id="chat.id" />
    </div>
    <woot-context-menu
      v-if="showContextMenu"
      ref="menu"
      :x="contextMenu.x"
      :y="contextMenu.y"
      @close="closeContextMenu"
    >
      <conversation-context-menu
        :status="chat.status"
        :inbox-id="inbox.id"
        :priority="chat.priority"
        :has-unread-messages="hasUnread"
        @update-conversation="onUpdateConversation"
        @assign-agent="onAssignAgent"
        @assign-label="onAssignLabel"
        @assign-team="onAssignTeam"
        @mark-as-unread="markAsUnread"
        @assign-priority="assignPriority"
      />
    </woot-context-menu>
  </a>
</template>
<script>
import { mapGetters } from 'vuex';
import { MESSAGE_TYPE } from 'widget/helpers/constants';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import Thumbnail from '../Thumbnail';
import conversationMixin from '../../../mixins/conversations';
import timeMixin from '../../../mixins/time';
import router from '../../../routes';
import { frontendURL, conversationUrl } from '../../../helper/URLHelper';
import InboxName from '../InboxName';
import inboxMixin from 'shared/mixins/inboxMixin';
import ConversationContextMenu from './contextMenu/Index.vue';
import alertMixin from 'shared/mixins/alertMixin';
import TimeAgo from 'dashboard/components/ui/TimeAgo';
import CardLabels from './conversationCardComponents/CardLabels.vue';
import PriorityMark from './PriorityMark.vue';
import LeadQualityCrown from 'dashboard/components/LeadQualityCrown.vue';
import LeadResponseWatch from 'dashboard/components/widgets/LeadResponseWatch.vue';
import { effectiveWaitingSinceUnixForConversation } from 'dashboard/helper/leadResponseWatch';
const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones-sound-wave',
  video: 'video',
  file: 'document',
  location: 'location',
  fallback: 'link',
};

export default {
  components: {
    CardLabels,
    InboxName,
    Thumbnail,
    ConversationContextMenu,
    TimeAgo,
    PriorityMark,
    LeadQualityCrown,
    LeadResponseWatch,
  },

  mixins: [
    inboxMixin,
    timeMixin,
    conversationMixin,
    messageFormatterMixin,
    alertMixin,
  ],
  props: {
    activeLabel: {
      type: String,
      default: '',
    },
    chat: {
      type: Object,
      default: () => {},
    },
    hideInboxName: {
      type: Boolean,
      default: false,
    },
    hideThumbnail: {
      type: Boolean,
      default: false,
    },
    teamId: {
      type: [String, Number],
      default: 0,
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
    showAssignee: {
      type: Boolean,
      default: false,
    },
    conversationType: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    showAssigneeName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hovered: false,
      showContextMenu: false,
      typing: false,
      typingTimeout: null, // Store the timeout reference
      contextMenu: {
        x: null,
        y: null,
      },
    };
  },
  mounted() {
    bus.$on('typing', this.typingMessage);

  // Log the chat object received from props
  // console.log('Chat object:', this.chat);
  },
 
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      inboxesList: 'inboxes/getInboxes',
      activeInbox: 'getSelectedInbox',
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      detachedListHighlight: 'getDetachedListHighlight',
    }),

    // contactchatLink() {
    //   console.log("this is the active chat gonig on --------------------------",this.isActiveChat);
    //   if (this.isActiveChat) {
    //       return;
    //     }
    //   let baseUrl = `/app/accounts/${this.$route.params.accountId}/conversations/${this.chat.id}`;
    //   // return this.pipelineContact ? `${baseUrl}?pipelineContact=true` : baseUrl;
    //   return baseUrl ;
    // },

    bulkActionCheck() {
      return !this.hideThumbnail && !this.hovered && !this.selected;
    },
    chatMetadata() {
      return this.chat.meta || {};
    },

    assignee() {
      if (this.chatMetadata.assignee) {
        return this.chatMetadata.assignee;
      }
      if (this.chat.assignee) {
        return this.chat.assignee;
      }
      if (this.chat.assignee_id) {
        return {
          id: this.chat.assignee_id,
          name: this.chat.assignee_name || 'Agent'
        };
      }
      if (this.chat.meta && this.chat.meta.assignee) {
        return this.chat.meta.assignee;
      }
      return {};
    },

    currentContact() {
      return this.$store.getters['contacts/getContact'](
        this.chatMetadata.sender.id
      );
    },

    lastMessageFileType() {
      const lastMessage = this.lastMessageInChat;
      const [{ file_type: fileType } = {}] = lastMessage.attachments;
      return fileType;
    },

    attachmentIcon() {
      return ATTACHMENT_ICONS[this.lastMessageFileType];
    },

    attachmentMessageContent() {
      return `CHAT_LIST.ATTACHMENTS.${this.lastMessageFileType}.CONTENT`;
    },

    isActiveChat() {
      if (this.detachedListHighlight?.alternateHighlight) return false;
      return this.currentChat.id === this.chat.id;
    },
    isDetachedHighlight() {
      if (
        this.hideThumbnail ||
        !this.detachedListHighlight?.alternateHighlight
      ) {
        return false;
      }
      return (
        Number(this.detachedListHighlight.anchorConversationId) ===
        Number(this.chat.id)
      );
    },

    unreadCount() {
      return this.chat.unread_count;
    },

    hasUnread() {
      return this.unreadCount > 0;
    },

    isInboxNameVisible() {
      return !this.activeInbox;
    },

    lastMessageInChat() {
      return this.lastMessage(this.chat);
    },

    messageByAgent() {
      const lastMessage = this.lastMessageInChat;
      const { message_type: messageType } = lastMessage;
      return messageType === MESSAGE_TYPE.OUTGOING;
    },

    isMessageAnActivity() {
      const lastMessage = this.lastMessageInChat;
      const { message_type: messageType } = lastMessage;
      return messageType === MESSAGE_TYPE.ACTIVITY;
    },

    isMessagePrivate() {
      const lastMessage = this.lastMessageInChat;
      const { private: isPrivate } = lastMessage;
      return isPrivate;
    },

    parsedLastMessage() {
      const { content_attributes: contentAttributes } = this.lastMessageInChat;
      const { email: { subject } = {} } = contentAttributes || {};
      return this.getPlainText(subject || this.lastMessageInChat.content);
    },

    inbox() {
      const { inbox_id: inboxId } = this.chat;
      const stateInbox = this.$store.getters['inboxes/getInbox'](inboxId);
      return stateInbox;
    },

    showInboxName() {
      return (
        !this.hideInboxName &&
        this.isInboxNameVisible &&
        this.inboxesList.length > 1
      );
    },
    inboxName() {
      const stateInbox = this.inbox;
      return stateInbox.name || '';
    },
    isSpecialRoute() {
      const { path, query } = this.$route;

      // Updated regex to match "/app/accounts/{id}/contacts/{contactId}"
      const specialRoutePattern = /^\/app\/accounts\/\d+\/contacts\/\d+$/;

      return specialRoutePattern.test(path) && !query.page; // Exclude routes with `page` query parameter
    },

    displayName() {
      if (this.showAssigneeName) {
        return this.assignee?.name || 'Unassigned';
      }
      return this.currentContact.name || this.chatMetadata.sender.name;
    },

    senderLeadQualityMetadata() {
      return (
        this.currentContact.lead_quality_metadata ||
        this.chatMetadata.sender?.lead_quality_metadata ||
        null
      );
    },

    chatChannelType() {
      const inboxId = this.chat?.inbox_id;
      if (!inboxId) return null;
      const inbox = this.$store.getters['inboxes/getInbox'](inboxId);
      return inbox?.channel_type || null;
    },
    displayWatchData() {
      const result = effectiveWaitingSinceUnixForConversation(
        this.chat,
        this.lastMessageInChat,
        this.chatChannelType,
        { store: this.$store, accountId: this.accountId }
      );
      if (result == null) return { unix: null, forceRed: false };
      if (typeof result === 'object') return result;
      return { unix: result, forceRed: false };
    },
  },
  methods: {

    // onCardClick(e) {
    //   const { activeInbox, chat } = this;
    //   const path = frontendURL(
    //     conversationUrl({
    //       accountId: this.accountId,
    //       activeInbox,
    //       id: chat.id,
    //       label: this.activeLabel,
    //       teamId: this.teamId,
    //       foldersId: this.foldersId,
    //       conversationType: this.conversationType,
    //     })
    //   );

    //   if (e.metaKey || e.ctrlKey) {
    //     window.open(
    //       window.chatwootConfig.hostURL + path,
    //       '_blank',
    //       'noopener noreferrer nofollow'
    //     );
    //     return;
    //   }
    //   if (this.isActiveChat) {
    //     return;
    //   }

    //   router.push({ path });
    // },


    onCardClick(e) {
      // if(!this.isSpecialRoute) {
        console.log("My e is",e,this);
        console.log("this is the data we need",this.activeInbox, this.chat)
        const { activeInbox, chat, currentContact } = this;
        
        const path = frontendURL(
          conversationUrl({
            accountId: this.accountId,
            activeInbox,
            id: chat.id,
            label: this.activeLabel,
            teamId: this.teamId,
            foldersId: this.foldersId,
            conversationType: this.conversationType,
          })
        );
  
        if (e.metaKey || e.ctrlKey) {
          window.open(
            window.chatwootConfig.hostURL + path,
            '_blank',
            'noopener noreferrer nofollow'
          );
          return;
        }
        // if(this.isActiveChat) {
        //   return;
        // }
        if (this.detachedListHighlight?.active) {
          this.$store.dispatch('clearDetachedListHighlight');
          if (this.$route.fullPath === path) {
            this.$store.dispatch('setActiveChat', { data: this.chat });
            return;
          }
        }
        if (this.$route.fullPath === path) {
          this.$forceUpdate();
          return;
        }
  
        router.push({ path });
      // }
  
    this.$emit('contact-selected', this.currentContact.name);
    },
    onCardHover() {
      this.hovered = !this.hideThumbnail;
    },
    onCardLeave() {
      this.hovered = false;
    },
    onSelectConversation(checked) {
      const action = checked ? 'select-conversation' : 'de-select-conversation';
      this.$emit(action, this.chat.id, this.inbox.id);
    },
    openContextMenu(e) {
      e.preventDefault();
      this.$emit('context-menu-toggle', true);
      // client* coordinates match position: fixed (viewport); page* would drift when the window is scrolled
      this.contextMenu.x = e.clientX;
      this.contextMenu.y = e.clientY;
      this.showContextMenu = true;
    },
    closeContextMenu() {
      this.$emit('context-menu-toggle', false);
      this.showContextMenu = false;
      this.contextMenu.x = null;
      this.contextMenu.y = null;
    },
    onUpdateConversation(status, snoozedUntil) {
      this.closeContextMenu();
      this.$emit(
        'update-conversation-status',
        this.chat.id,
        status,
        snoozedUntil
      );
    },
    async onAssignAgent(agent) {
      this.$emit('assign-agent', agent, [this.chat.id]);
      this.closeContextMenu();
    },
    async onAssignLabel(label) {
      this.$emit('assign-label', [label.title], [this.chat.id]);
      this.closeContextMenu();
    },
    async onAssignTeam(team) {
      this.$emit('assign-team', team, this.chat.id);
      this.closeContextMenu();
    },
    async markAsUnread() {
      this.$emit('mark-as-unread', this.chat.id);
      this.closeContextMenu();
    },
    async assignPriority(priority) {
      this.$emit('assign-priority', priority, this.chat.id);
      this.closeContextMenu();
    },
    typingMessage(conversationId) {
       setTimeout(() => {
       // console.log('conversationId:', conversationId);
       // console.log('this.chat.id:', this.chat.id);

       if (conversationId === this.chat.id) {
          // console.log('Conversation IDs match. Starting typing...');
          this.startTyping();
       } else {
         // console.log('Conversation IDs do not match. Stopping typing...');
        this.stopTyping();
      }
    }, 100); // Add a slight delay
   },

    startTyping() {
      // If the user is typing, set typing to true
      this.typing = true;

      // Clear any existing timeout to avoid resetting too early
      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
      }

      // Set typing to false after 2 seconds of inactivity
      this.typingTimeout = setTimeout(() => {
        this.typing = false;
      }, 1000); // 1 seconds
    },
    stopTyping() {
      // Immediately stop typing and clear any existing timeout
      this.typing = false;
      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text-weight{
  font-weight: 500 !important;
}
// .text-color-up{
//   color: #BEBEBE;
//   font-family: "Pacaembu Trial Light";
// }
// .text-color{
//   color: #4B5155 !important;
//   font-family: "Pacaembu Trial Medium";
// }
.bgchange {
  background-color: #f4f8fc !important;
  border-radius: 10px;
  margin: 10px;
}
.bg-custom-color {
  background-color: #40518a;
}
.active-class {
  // background-color: aliceblue !important;
  background-color: #f4f8fc !important;
  border-radius: 10px;
}
.detached-highlight {
  background-color: #ffe7c2 !important;
  border-radius: 10px;
}
.dark .detached-highlight {
  background-color: #5a4320 !important;
}
.conversation {
  &.unread-chat {
    .unread {
      @apply block;
    }
    .conversation--message {
      @apply font-semibold;
    }
    .conversation--user {
      @apply font-semibold;
    }
  }

  &.compact {
    @apply pl-0;
    .conversation--details {
      @apply rounded-sm ml-0 pl-5 pr-2;
    }
  }

  &:deep(.user-thumbnail-box) {

    @apply mt-4;
  }

  &.conversation-selected {
    @apply bg-slate-25 dark:bg-slate-800;
  }

  &.has-inbox-name {
    &:deep(.user-thumbnail-box) {

      @apply mt-8;
    }
    .checkbox-wrapper {
      @apply mt-8;
    }
    .conversation--meta {
      @apply mt-0;
    }
  }

  .checkbox-wrapper {
    @apply h-10 w-10 flex items-center justify-center rounded-full cursor-pointer mt-4 hover:bg-woot-100 dark:hover:bg-woot-800;

    input[type='checkbox'] {
      @apply m-0 cursor-pointer;
    }
  }
  .thumbnail-columns {
    margin-top: 0.6rem !important;
    margin-bottom: 0.6rem;
    height: 50px;
    width: 50px;
  }
  .custom-font-family{
    font-family: "Pacaembu Trial Light" !important; 
  }
}
</style>
